import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigInitializerService {
  private config: { googleClientId?: string; microsoftClientId?: string } = {};
  // Plain client without the app's interceptors, which are not ready before APP_INITIALIZER finishes
  private http: HttpClient;

  constructor(httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend);
  }

  // The public Google and Microsoft client ids come from api/Config/ExternalLoginClientIds (AWS on the API side).
  // The environment file values are only a fallback when that call fails or returns an empty id.
  async loadConfig(): Promise<void> {
    try {
      const ids = await firstValueFrom(
        this.http.get<{ googleClientId?: string; microsoftClientId?: string }>(`${environment.WebApiURL}api/Config/ExternalLoginClientIds`)
          // Short limit so the app is not held up; a slow API falls back to the environment file values
          .pipe(timeout(5000)));
      this.config.googleClientId = ids?.googleClientId || environment.googleClientId;
      this.config.microsoftClientId = ids?.microsoftClientId || environment.microsoftClientId;
    } catch (error) {
      console.warn('Could not load the sign-in client ids from the API; using the environment file.', error);
      this.config.googleClientId = environment.googleClientId;
      this.config.microsoftClientId = environment.microsoftClientId;
    }
    if (!this.config.googleClientId) {
      console.warn('googleClientId is not set; Google sign-in is disabled.');
    }
    if (!this.config.microsoftClientId) {
      console.warn('microsoftClientId is not set; Microsoft sign-in is disabled.');
    }
  }

  getGoogleClientId(): string {
    return this.config.googleClientId || '';
  }

  getMicrosoftClientId(): string {
    return this.config.microsoftClientId || '';
  }
}
